import React, { useState, useEffect, useCallback } from 'react';
import { adminUsers } from '../../utils/api';
import toast from 'react-hot-toast';

const AdminCustomers = () => {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    adminUsers.getAll({ page, search, limit: 20 })
      .then(d => { setUsers(d.users || []); setTotal(d.total || 0); setPages(d.pages || 1); })
      .catch(err => toast.error(err.message))
      .finally(() => setLoading(false));
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="admin-page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <h2 style={{ fontFamily:'var(--font-serif)', fontSize:'1.5rem' }}>
            Customers <span style={{ fontSize:'1rem', color:'var(--text-muted)', fontFamily:'var(--font-sans)' }}>({total})</span>
          </h2>
        </div>
      </div>

      <div style={{ display:'flex', gap:12, marginBottom:16 }}>
        <input
          className="form-control"
          placeholder="Search by email, first name or last name..."
          value={search}
          onChange={e => { setSearch(e.target.value); setPage(1); }}
          style={{ maxWidth:380 }}
        />
      </div>

      <div className="admin-card">
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Orders</th>
                <th>Status</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" style={{ textAlign:'center', padding:40 }}><div className="spinner" style={{ margin:'0 auto' }} /></td></tr>
              ) : users.length === 0 ? (
                <tr><td colSpan="6" style={{ textAlign:'center', padding:40, color:'var(--text-muted)' }}>No customers found.</td></tr>
              ) : users.map(u => (
                <tr key={u.id}>
                  <td>
                    <strong style={{ fontSize:'0.9rem' }}>
                      {(u.first_name || u.last_name) ? `${u.first_name || ''} ${u.last_name || ''}`.trim() : '—'}
                    </strong>
                  </td>
                  <td style={{ fontSize:'0.85rem' }}>{u.email}</td>
                  <td style={{ fontSize:'0.82rem', color:'var(--text-muted)' }}>{u.phone || '—'}</td>
                  <td><strong>{u.order_count || 0}</strong></td>
                  <td>
                    {u.is_active
                      ? <span className="badge badge-olive">Active</span>
                      : <span className="badge badge-red">Disabled</span>}
                  </td>
                  <td style={{ fontSize:'0.82rem', color:'var(--text-muted)' }}>
                    {u.created_at ? new Date(u.created_at).toLocaleDateString() : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {pages > 1 && (
          <div className="admin-pagination">
            <button disabled={page===1} onClick={() => setPage(p=>p-1)}>← Prev</button>
            <span>Page {page} of {pages}</span>
            <button disabled={page===pages} onClick={() => setPage(p=>p+1)}>Next →</button>
          </div>
        )}
      </div>

      <style>{`
        .admin-card { background: white; border-radius: var(--radius-lg); padding: 20px; box-shadow: var(--shadow-sm); }
        .admin-table-wrap { overflow-x: auto; }
        .admin-table { width: 100%; border-collapse: collapse; }
        .admin-table th { text-align: left; padding: 10px 12px; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.5px; color: var(--text-muted); border-bottom: 2px solid var(--border); }
        .admin-table td { padding: 12px; font-size: 0.85rem; border-bottom: 1px solid #f5f5f5; vertical-align: middle; }
        .admin-table tr:hover td { background: #fafafa; }
        .admin-pagination { display: flex; align-items: center; justify-content: center; gap: 16px; margin-top: 20px; font-size: 0.88rem; }
        .admin-pagination button { padding: 8px 16px; border-radius: 8px; background: var(--cream); font-family: var(--font-sans); }
        .admin-pagination button:disabled { opacity: 0.4; }
      `}</style>
    </div>
  );
};

export default AdminCustomers;
